import { render, staticRenderFns } from "./ImagesLABNonRecently_ViewImagesSeries.vue?vue&type=template&id=513bb149"
import script from "./ImagesLABNonRecently_ViewImagesSeries.vue?vue&type=script&lang=js"
export * from "./ImagesLABNonRecently_ViewImagesSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports